import { all, put, call, delay, takeEvery, take, fork, cancel, takeLatest, cancelled, race } from 'redux-saga/effects';

import * as actions from 'reducer/actionTypes'
import * as api from 'script/api'

export default function* fetchMonitoring(){
	yield all([
		yield takeEvery(actions.FETCH_REALTIME_MONITORING_DATA_REQUEST, fetchRealTimeMonitoringData),
	])
}

function* fetchRealTimeMonitoringData() {
	yield race([
		call(getMonitoringData),
		take(actions.FETCH_REALTIME_MONITORING_DATA_REQUEST_STOP)
	])
}

function* getMonitoringData() {
	try {
		while(true) {
			const result = yield call(api.getMonitoringData);
			yield put ({
				type: actions.FETCH_REALTIME_MONITORING_DATA_SUCCESS,
				value: result.data
			})

			yield delay(10 *1000); //10 seconds
		}
	} finally {
		if (yield cancelled) {
		}
	}
}
